import React from 'react'
import { useQuery } from '@apollo/client'
import { Loading } from '@winnin/winnin_ui.components.loading'

import CreatorCardMiniWithTolgee from 'components/CreatorCardMiniWithTolgee'
import { countries, makeUrlTo } from 'utils'

import { CREATOR_QUERY } from './query'

function CreatorCardSmall({ ...props }) {
  const {
    isBrandGroup,
    subscribers: subscribersValue,
    subscribersVariation,
    country: countryValue,
    title,
    thumbnail,
    isBrand,
    groupId,
    isTrending,
    provider,
    id,
  } = props
  const baseUrl = makeUrlTo.creator({ groupId, provider, creatorId: id })
  return (
    <CreatorCardMiniWithTolgee
      subscribers={{
        value: subscribersValue,
        variation: subscribersVariation,
      }}
      isBrandGroup={isBrandGroup}
      country={countries.byValue(countryValue).NAME}
      title={title}
      thumbnail={thumbnail}
      isBrand={isBrand}
      groupId={groupId}
      isTrending={isTrending}
      provider={provider}
      id={id}
      link={{ link: baseUrl }}
      disableRefresh
    />
  )
}

const CreatorCardFetcher = ({ id, provider }) => {
  const { loading, error, data, refetch } = useQuery(CREATOR_QUERY, {
    variables: {
      _id: `${provider}:${id}`,
    },
  })

  const handleTryAgainClick = e => {
    e.stopPropagation()
    refetch()
  }

  if (loading) {
    return (
      <div className="CreatorCardFetcher-loading">
        <Loading />
      </div>
    )
  }

  if (error) {
    return (
      <div className="CreatorCardFetcher-error">
        Error on load creator data, <button onClick={handleTryAgainClick}>Try Again</button>
      </div>
    )
  }

  if (!data?.creator) return <p>No data available.</p>

  const creator = data?.creator
  const {
    title,
    country,
    thumbnail,
    subscribers,
    subscribersVariation,
    isBrand,
    groupId,
    topics,
    isFollowing,
    isTrending,
    isBrandGroup,
  } = creator

  return (
    <div className="CreatorCardFetcher">
      <CreatorCardSmall
        title={title}
        country={country}
        thumbnail={thumbnail}
        provider={provider}
        subscribers={subscribers}
        subscribersVariation={subscribersVariation}
        isBrand={isBrand}
        groupId={groupId}
        id={id}
        subscribersLabel="Subs"
        topics={topics}
        isFollowing={isFollowing}
        isTrending={isTrending}
        isBrandGroup={isBrandGroup}
      />
    </div>
  )
}

export default CreatorCardFetcher
